/**
 * Organization trainees analytics API – all endpoints used by organization trainee analytics pages.
 * Base path: /admin/trainees (organization trainees routes mounted in backend admin routes).
 */
import { GET, POST } from '../../apiController';

const TRAINEES = '/admin/trainees';

// Get trainee analytics data
export const getTraineeAnalytics = (data) => {
  return POST(TRAINEES + `/trainee_analytics`, data);
};

export const getTraineeBehaviourAnalytics = (data) => {
  return POST(TRAINEES + `/trainee_behaviour_analytics`, data);
};

/** GET — full trainee analytics + gamification (same scope as Trainee Analytics page) for export */
export const getSingleTraineeAnalyticsReport = (traineeId) => {
  return GET(`${TRAINEES}/trainee_analytics_report/${encodeURIComponent(traineeId)}`);
};

// Get all trainees gamification data with pagination and search
export const getAllTraineesGamificationData = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(TRAINEES + `/admin/gamification/trainees?${queryString}`);
};

// Get individual trainee gamification data
export const getTraineeGamificationData = (traineeId) => {
  return GET(TRAINEES + `/admin/gamification/trainee/${traineeId}`);
};

// Get gamification leaderboard
export const getGamificationLeaderboard = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return GET(TRAINEES + `/admin/gamification/leaderboard?${queryString}`);
};

// Get gamification stats
export const getGamificationStats = () => {
  return GET(TRAINEES + `/admin/gamification/stats`);
};
